/* Copyright (c) 2017 Backpack Health LLC */

import * as _ from 'lodash';

import PolicyService from '../../../apiServices/PolicyService';
import { PolicyInterface, PolicyLocalizationInterface } from '../../../models/PolicyModel';

export const types = {
  REQUEST_ALL: 'app/policy/REQUEST_ALL',
  RECEIVE_ALL: 'app/policy/RECEIVE_ALL',
};

const initialState = {
  collection: [],
};

export default function reducer(state = initialState, action: { type: string; payload: object }) {
  switch (action.type) {
    case types.REQUEST_ALL:
    case types.RECEIVE_ALL:
      return _.assign({}, state, action.payload);
    default:
      return state;
  }
}

export const selectors = {
  getAll: (state) => state.policy.collection,
  getLocalizationByName(state: object, name: string, languageCode: string): PolicyLocalizationInterface {
    const policy = _.get(state, 'policy.collection', []).filter(p => p.name === name)[0];
    return policy ? policy.i18n[languageCode] : null;
  },
  getPolicyByName(state: object, name: string): PolicyInterface {
    return _.get(state, 'policy.collection', []).filter(p => p.name === name)[0];
  },
  getPolicyById(state: object, id: number): PolicyInterface {
    return _.get(state, 'policy.collection', []).filter(p => p.id === id)[0];
  },
};

function receivePolicies(policies) {
  return {
    type: types.REQUEST_ALL,
    payload: {
      collection: policies,
    },
  };
}

function requestAllPolicies() {
  return (dispatch) => {
    return new Promise((res, rej) => {
      PolicyService.getAll((err, policies) => {
        if (err) { return rej(err); }

        dispatch(receivePolicies(policies));
        res(policies);
      });
    });
  };
}

export const actions = {
  requestAllPolicies,
};
